<script lang="ts">
	import type { IEventSlot } from '@api/EventSlotsApi';
	import SectionHeadline from './SectionHeadline.svelte';
	import EventTile from './EventTile.svelte';

	export let relatedEvents: IEventSlot[] = [];
</script>

<div class="content-module-padding my-12">
	<SectionHeadline {...$$restProps}
		>Diese Events und Workshops könnten dich auch interessieren</SectionHeadline
	>

	<div
		class="grid grid-cols-[repeat(auto-fill,minmax(18.5rem,1fr))] flex-wrap gap-6 justify-center lg:pl-9"
	>
		{#each relatedEvents as event (event.id)}
			<EventTile {event} loading="lazy" />
		{/each}
	</div>
</div>
